import React, { useState, useEffect } from 'react';
import { useAuth } from '../../contexts/AuthContext';
import WebsiteImagesManager from '../../components/admin/WebsiteImagesManager';
import GalleryManager from '../../components/admin/GalleryManager';
import GalleryFolderManager from '../../components/admin/GalleryFolderManager';

const AdminDashboard = () => {
    const { logout } = useAuth();
    const [activeTab, setActiveTab] = useState('gallery');

    useEffect(() => {
    }, []);

    return (
        <div className="min-h-screen bg-neutral-50">
            {/* Add top padding to prevent content being hidden behind navbar */}
            <div className="pt-24">
                <div className="bg-white shadow-sm border-b border-neutral-200">
                    <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
                        <div className="flex justify-between items-center py-6">
                            <h1 className="text-3xl font-bold text-neutral-950">Admin Dashboard</h1>
                            <button
                                onClick={logout}
                                className="bg-red-600 hover:bg-red-700 text-white px-4 py-2 rounded-md font-medium transition-colors"
                            >
                                Abmelden
                            </button>
                        </div>
                    </div>
                </div>

                <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-8">
                    {/* Tab Navigation */}
                    <div className="border-b border-neutral-200 mb-6">
                        <nav className="-mb-px flex space-x-8">
                            <button
                                onClick={() => setActiveTab('gallery')}
                                className={`py-2 px-1 border-b-2 font-medium text-sm transition-colors ${activeTab === 'gallery'
                                    ? 'border-primary-500 text-primary-600'
                                    : 'border-transparent text-neutral-600 hover:text-neutral-800 hover:border-neutral-300'
                                    }`}
                            >
                                Galerie
                            </button>
                            <button
                                onClick={() => setActiveTab('gallery-folders')}
                                className={`py-2 px-1 border-b-2 font-medium text-sm transition-colors ${activeTab === 'gallery-folders'
                                    ? 'border-primary-500 text-primary-600'
                                    : 'border-transparent text-neutral-600 hover:text-neutral-800 hover:border-neutral-300'
                                    }`}
                            >
                                Galerie Ordner
                            </button>
                            <button
                                onClick={() => setActiveTab('website-images')}
                                className={`py-2 px-1 border-b-2 font-medium text-sm transition-colors ${activeTab === 'website-images'
                                    ? 'border-primary-500 text-primary-600'
                                    : 'border-transparent text-neutral-600 hover:text-neutral-800 hover:border-neutral-300'
                                    }`}
                            >
                                Website-Bilder
                            </button>
                        </nav>
                    </div>

                    {/* Gallery Tab */}
                    {activeTab === 'gallery' && (
                        <div className="bg-white shadow-sm rounded-lg border border-neutral-200 p-6">
                            <GalleryManager />
                        </div>
                    )}

                    {/* Gallery Folders Tab */}
                    {activeTab === 'gallery-folders' && (
                        <div className="bg-white shadow-sm rounded-lg border border-neutral-200 p-6">
                            <GalleryFolderManager />
                        </div>
                    )}

                    {/* Website Images Tab */}
                    {activeTab === 'website-images' && (
                        <div className="bg-white shadow-sm rounded-lg border border-neutral-200 p-6">
                            <WebsiteImagesManager />
                        </div>
                    )}
                </div>
            </div>
        </div>
    );
};

export default AdminDashboard;
